<template>

<div class="section">

    <div class="section-head" v-if="title">

        {{ title }}

    </div>

    <div class="section-content">

        <slot></slot>

    </div>

</div>

</template>

<script>

export default {

    props: ['title']

}

</script>

<style scoped>

.section {
    border-bottom: 1px solid var(--color-grey-light);
    padding: 20px;
}

.is-mobile .section {
    padding: 10px;
}

.section-head {
    margin-bottom: 20px;
    text-align: center;
    color: var(--color-blue-dark);
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 1px;
    margin-bottom: 20px;
}

.section:last-child {
    border-bottom-width: 0px;
}

</style>
